import type {Vehicle} from "../types";
import {getUserPrimaryHouseholdId} from "@/src/modules/users/lib/helpers";

/**
 * Resolves household id from API shapes:
 * - `house_hold_id` on the vehicle root
 * - `house_hold.house_hold_id` (common on list/detail)
 * - `resident.memberships[0].house_hold_id` when full user embed is present
 */
export function getVehicleHouseholdId(vehicle: Vehicle | null | undefined): number | null {
  if (!vehicle) return null;
  if (vehicle.house_hold_id != null && vehicle.house_hold_id !== 0) {
    return vehicle.house_hold_id;
  }
  const fromEmbed = vehicle.house_hold?.house_hold_id;
  if (fromEmbed != null && fromEmbed !== 0) return fromEmbed;
  const fromResident = getUserPrimaryHouseholdId(vehicle.resident);
  if (fromResident != null && fromResident !== 0) return fromResident;
  return null;
}
